import type { Object3D } from 'three';

import type { ObjectMetadata, SceneObject } from '../../../types/engine.types';

/**
 * Recursively collect all objects with IDs from a hierarchy
 */
export const collectObjectsWithIds = (
	object: Object3D,
	parentMetadata: ObjectMetadata,
	result: Map<string, SceneObject>,
	depth = 0
): void => {
	// Check if this object has an ID
	if (object.userData?.id) {
		const metadata: ObjectMetadata = {
			id: object.userData.id,
			type: object.userData.type || parentMetadata.type,
			subtype: object.userData.subtype,
			source: parentMetadata.source,
			sku: object.userData.sku,
			hash: object.userData.hash
		};

		result.set(object.userData.id, { object, metadata });
	}

	// Process children
	for (const child of object.children) {
		collectObjectsWithIds(child, parentMetadata, result, depth + 1);
	}
};
